import { useEffect, useState } from "react";
import { FileUp } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const WeeklySpNotesPanel = ({ placements = [] }) => {
  const [placementId, setPlacementId] = useState("");
  const [weekEnding, setWeekEnding] = useState("");
  const [report, setReport] = useState(null);
  const [notes, setNotes] = useState([]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function load() {
    try {
      const response = await api.get("/weekly-sp-notes");
      setNotes(response.data);
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function submit(event) {
    event.preventDefault();
    try {
      const data = new FormData();
      data.append("placement_id", placementId);
      data.append("week_ending", weekEnding);
      data.append("report", report);
      await api.post("/weekly-sp-notes", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setReport(null);
      setMessage("Weekly SP Notes PDF submitted for TAG approval.");
      setError("");
      await load();
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  }

  return (
    <section className="provider-invoices-panel" data-testid="weekly-sp-notes-panel">
      <div className="section-heading">
        <div>
          <h2>Weekly SP Notes PDF Submission</h2>
          <p>Upload the completed PDF for an assigned school and week-ending date.</p>
        </div>
      </div>
      {error && <p className="form-message error-message">{error}</p>}
      {message && <p className="form-message success-message">{message}</p>}
      <form className="provider-invoice-form" data-testid="weekly-sp-notes-form" onSubmit={submit}>
        <label>
          Assigned school
          <select
            data-testid="sp-note-placement-select"
            required
            value={placementId}
            onChange={(event) => setPlacementId(event.target.value)}
          >
            <option value="">Select placement</option>
            {placements.map((placement) => (
              <option key={placement.id} value={placement.id}>
                {placement.title}
              </option>
            ))}
          </select>
        </label>
        <label>
          Week ending
          <input
            data-testid="sp-note-week-ending-input"
            required
            type="date"
            value={weekEnding}
            onChange={(event) => setWeekEnding(event.target.value)}
          />
        </label>
        <label>
          Completed SP Notes PDF
          <input
            accept="application/pdf,.pdf"
            data-testid="sp-note-pdf-input"
            required
            type="file"
            onChange={(event) => setReport(event.target.files?.[0] || null)}
          />
        </label>
        <button
          className="button button-primary"
          data-testid="submit-sp-note-button"
          disabled={!report}
        >
          <FileUp size={16} /> Submit PDF for approval
        </button>
      </form>
      <div className="provider-invoice-list">
        {notes.map((note) => (
          <p key={note.id}>
            <strong>{note.week_ending}</strong>
            <span>
              {note.status} · {note.original_filename}
            </span>
          </p>
        ))}
        {!notes.length && (
          <p className="provider-empty-state">No weekly SP Notes PDFs have been submitted yet.</p>
        )}
      </div>
    </section>
  );
};
